import { render, staticRenderFns } from "./SingleCommissionRoExpected.vue?vue&type=template&id=80aac974"
import script from "./SingleCommissionRoExpected.vue?vue&type=script&lang=js"
export * from "./SingleCommissionRoExpected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports